import 'css-chunksrc/client/pages/projectPage/resourcesPage/groupsList/styles.scss';export default {
  "groupsList": "_groupsList_6rdh5_1",
  "group": "_group_6rdh5_1",
  "groupHeader": "_groupHeader_6rdh5_24",
  "name": "_name_6rdh5_34",
  "members": "_members_6rdh5_40",
  "icon": "_icon_6rdh5_45",
  "resourcesList": "_resourcesList_6rdh5_51",
  "heading": "_heading_6rdh5_58",
  "label": "_label_6rdh5_67",
  "cogWheel": "_cogWheel_6rdh5_76",
  "cogIcon": "_cogIcon_6rdh5_85",
  "main": "_main_6rdh5_92",
  "list": "_list_6rdh5_101",
  "item": "_item_6rdh5_106",
  "contextualMenu": "_contextualMenu_6rdh5_110",
  "button": "_button_6rdh5_114",
  "toggleIcon": "_toggleIcon_6rdh5_131",
  "actions": "_actions_6rdh5_137",
  "action": "_action_6rdh5_137",
  "buttonText": "_buttonText_6rdh5_154"
};